import { FC } from "react";

import { PageContextWrapper } from "@ryde/controls";
import { LayoutCrudRoutes, PageClientSideFilters } from "@ryde/layout";

export const FeedbackSolutionsPage: FC = () => {
  return (
    <PageContextWrapper entity="feedbackSolution">
      <PageClientSideFilters />
      <LayoutCrudRoutes />
    </PageContextWrapper>
  );
};
